import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useAirportPickupBasicRateSubmit from "hooks/useAirportPickupBasicRateSubmit";
import DynamicAirportPickupInput from "components/form/DynamicAirportPickupInput";
import SelectSingleAirportOnly from "components/form/SelectSingleAirportOnly";

import React from "react";
import Scrollbars from "react-custom-scrollbars-2";

const AirportPickupBasicRateDrawer = ({ id }) => {
  const {
    setSelectedOptions,
    selectedOptions,
    handleVehicleCategoryChange,
    setDataInput,
    dataInput,
    handleChangeInput,
    register,
    handleSubmit,
    selectedCity,
    onSubmit,
    handleCityChange,
    selectedVehicleCategory,
    trigger,
    errors,
    primeAvailable,
  } = useAirportPickupBasicRateSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Airport Pickup Basic Rate"} description={""} />
        ) : (
          <Title title={"Add Airport Pickup Basic Rate"} description={""} />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-6 gap-3 mb-6">
              <div className="col-span-8 sm:col-span-4">
                <LabelArea label={"Name of the Airport"} />
                <SelectSingleAirportOnly
                  register={register}
                  label="Name of the Airport"
                  name="name_of_aiport"
                  type="text"
                  placeholder={"--Choose--"}
                  selectedCity={selectedCity}
                  handleCityChange={handleCityChange}
               
                />
                <Error errorName={errors.name_of_aiport} />
              </div>
              <DynamicAirportPickupInput
                register={register}
                trigger={trigger}
                errors={errors}
                dataInput={dataInput}
                setDataInput={setDataInput}
                handleChange={handleChangeInput}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                handleVehicleCategoryChange={handleVehicleCategoryChange}
                selectedVehicleCategory={selectedVehicleCategory}
                primeAvailable={primeAvailable}
              />
            </div>
          </div>

          <DrawerButton id={id} title={id ? "Update" : "Submit"} />
        </form>
      </Scrollbars>
    </>
  );
};

export default AirportPickupBasicRateDrawer;
